import React, { useState, useEffect } from 'react';

// Common user agent patterns that indicate the site is loaded in an app WebView
const WEBVIEW_PATTERNS = [
  // Android WebView
  / wv\)/,
  /Android.*Version\/[0-9.]+/,
  // iOS WebView
  /iPhone.*AppleWebKit(?!.*Safari)/,
  /iPad.*AppleWebKit(?!.*Safari)/,
  // Common app WebView identifiers
  /; wv/,
  / FB_/,
  /FBAN\//,
  /FBAV\//,
  /Instagram/,
  /Twitter/,
  /LinkedInApp/,
];

// Store the result to avoid recalculation and flicker
let cachedAppModeResult = null;

// This function checks if the current device is likely an app WebView
export const isRunningInAppWebView = () => {
  // Return cached result if available (prevents recalculation during component remounts)
  if (cachedAppModeResult !== null) return cachedAppModeResult;
  
  if (typeof window === 'undefined') return false;
  
  const userAgent = window.navigator.userAgent || '';
  
  // Check for URL parameter first - highest priority
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('app') === 'true') {
    cachedAppModeResult = true;
    return true;
  }
  
  // Check if site is loaded in iframe
  if (window.self !== window.top) {
    cachedAppModeResult = true;
    return true;
  }
  
  // Check for app-specific user agent patterns
  const isApp = WEBVIEW_PATTERNS.some(pattern => pattern.test(userAgent));
  cachedAppModeResult = isApp;
  return isApp;
};

// Force app mode for testing
export const forceAppMode = (isApp = true) => {
  cachedAppModeResult = isApp;
};

const AppModeDetector = ({ children }) => {
  const [isAppMode, setIsAppMode] = useState(false);
  
  useEffect(() => {
    // Check immediately and set state
    setIsAppMode(isRunningInAppWebView());
    
    // No need to add cleanup as we're using a static cache
  }, []);
  
  return children(isAppMode);
};

export default AppModeDetector; 